import { Button, Divider, Paper, Typography } from '@mui/material'
import { useState } from 'react'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import ErrorIcon from '@mui/icons-material/Error'
import useStyles from './useStyles'
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined'
import { enableMEFullVersionEAutz } from '../../../app/services/eAuth/eAuthz/enableMEFullVersionEAutz'
import ProcessDetails from '../../../components/Modals/Import-csv/ProcessDetails'
import { createTheme, ThemeProvider } from '@mui/material/styles'

const theme = createTheme({
  palette: {
    warning: {
      main: '#EFBA1B',
      contrastText: '#fff'
    }
  }
})
function UploadFile ({ setLoading }) {
  const classes = useStyles()
  const [selectedFile, setSelectedFile] = useState(null)
  const [success, setSuccess] = useState(false)
  const [successWithError, setsuccessWithError] = useState(false)
  const [errorByParams, seterrorByParams] = useState(false)
  const [error, setError] = useState(false)
  const [openmodalDetails, setopenmodalDetails] = useState(false)

  const [processResponse, setprocessResponse] = useState(null)

  const handleFileInput = (event) => {
    setSuccess(false)
    setsuccessWithError(false)
    setError(false)
    setSelectedFile(event.target.files[0])
  }

  const handleUpload = async () => {
    setLoading(true)
    setSuccess(false)
    setsuccessWithError(false)
    setError(false)
    seterrorByParams(false)
    try {
      const response = await enableMEFullVersionEAutz(selectedFile)
      if (response.data) {
        response.data?.failures?.length > 0
          ? setsuccessWithError(true)
          : setSuccess(true)
        setprocessResponse(response.data)
      }
      // {
      //   "status": "Error",
      //   "code": 500,
      //   "message": "Parameters 'organizationCuit','startDate','User_MaxFirmStaffCount', 'FirmCustomer_MaxFirmCustomerCount','User_MaxFirmCustomerStaffCount' or Storage_MaxCapacityGB is not defined in line 1 ",
      //   "codeMessageLanguage": "eAuthzErrorUndefinedRequestParameter"
      // }
    } catch (error) {
      error?.response?.data?.codeMessageLanguage ===
      'eAuthzErrorUndefinedRequestParameter'
        ? seterrorByParams(true)
        : setError(true)
    }
    setLoading(false)
  }

  const DescargarModelo = async () => {
    try {
      const response = await fetch(
        process.env.PUBLIC_URL + '/Modelo_de_documento.csv'
      )
      const data = await response.blob()
      const url = window.URL.createObjectURL(new Blob([data]))
      const enlace = document.createElement('a')
      enlace.href = url
      enlace.download = 'Modelo_de_documento.csv'
      enlace.click()
    } catch (error) {
      console.error('Error al descargar el archivo CSV:', error)
    }
  }
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        width: '90%'
      }}
    >
      <Paper
        component="form"
        sx={{
          p: '4px 4px',
          display: 'flex',
          alignItems: 'center',
          width: '40%',
          background: '#E5E5E5'
        }}
      >
        <input
          hidden
          id="raised-button-file"
          type="file"
          multiple="multiple"
          onChange={handleFileInput}
        />
        <label htmlFor="raised-button-file" className={classes.input}>
          <FileUploadOutlinedIcon color="blue" className={classes.iconInput} />
          <p className={classes.text}>
            {selectedFile ? selectedFile.name : 'Seleccionar documento'}
          </p>
        </label>
        <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
        <Button
          variant="contained"
          className={classes.upload}
          onClick={handleUpload}
        >
          Subir
        </Button>
      </Paper>
      {success && (
        <>
          <CheckCircleIcon
            fontSize="large"
            color="success"
            style={{ marginLeft: 5 }}
          />
          <Typography
            style={{ color: '#2C3532', fontWeight: 'bold', marginLeft: 2 }}
          >
            Proceso exitoso
          </Typography>
        </>
      )}
      {successWithError && (
        <>
          <ThemeProvider theme={theme}>
            <CheckCircleIcon
              fontSize="large"
              color="warning"
              style={{ marginLeft: 5 }}
            />
            <div
              style={{
                color: '#2C3532'
              }}
            >
              <Typography
                style={{
                  fontWeight: 'bold',
                  marginLeft: 2,
                  fontSize: 13
                }}
              >
                El proceso se completó con éxito aunque presenta varios errores.
              </Typography>
              <div style={{ display: 'flex' }}>
                <Typography
                  style={{
                    fontWeight: 'bold',
                    marginLeft: 2,
                    fontSize: 13
                  }}
                >
                  Para ver más información
                </Typography>
                <Typography
                  style={{
                    fontWeight: 'bold',
                    marginLeft: 2,
                    fontSize: 13,
                    cursor: 'pointer',
                    color: '#EFBA1B'
                  }}
                  sx={{
                    '&:hover': {
                      fontSize: 14
                    }
                  }}
                  onClick={() => setopenmodalDetails(true)}
                >
                  presione aquí
                </Typography>
              </div>
            </div>
          </ThemeProvider>
        </>
      )}
      {error && (
        <>
          <ErrorIcon fontSize="large" color="error" />
          <Typography
            style={{ color: '#2C3532', fontWeight: 'bold', marginLeft: 2 }}
          >
            Error en el proceso
          </Typography>
        </>
      )}
      {errorByParams && (
        <>
          <ThemeProvider theme={theme}>
            <CheckCircleIcon
              fontSize="large"
              color="warning"
              style={{ marginLeft: 5 }}
            />
            <div
              style={{
                color: '#2C3532'
              }}
            >
              <Typography
                style={{
                  fontWeight: 'bold',
                  marginLeft: 2,
                  fontSize: 13
                }}
              >
                El documento es incorrecto.
              </Typography>
              <div style={{ display: 'flex' }}>
                <Typography
                  style={{
                    fontWeight: 'bold',
                    marginLeft: 2,
                    fontSize: 13
                  }}
                >
                  Para visualizar un documento de ejemplo
                </Typography>
                <Typography
                  style={{
                    fontWeight: 'bold',
                    marginLeft: 2,
                    fontSize: 13,
                    cursor: 'pointer',
                    color: '#EFBA1B',
                    textDecoration: 'underline'
                  }}
                  sx={{
                    '&:hover': {
                      fontSize: 14
                    }
                  }}
                  onClick={() => DescargarModelo(true)}
                >
                  presione aquí
                </Typography>
              </div>
            </div>
          </ThemeProvider>
        </>
      )}
      <ProcessDetails
        open={openmodalDetails}
        setOpen={setopenmodalDetails}
        process={processResponse}
      />
    </div>
  )
}

export default UploadFile
